import Update from "../table/Update"
import { useParams,useNavigate } from "react-router-dom"
import { useState,useEffect } from "react"
import ApiService from "../../services/apiService";
import { method } from "lodash";
import { error } from "console";
import { toast } from "react-toastify";


const PowerConsumptionUpdate =() =>{

    const navigate = useNavigate();
    const {Id} = useParams();
    const [data,setData] = useState<any>()
    const [pumpStationData, setPumpStationData] = useState<any[]>()

    const initialData = {
         DateTime:data?.dateTime,
         PowerConsumption_KWH:data?.powerConsumption_KWH
    }

    useEffect(()=>{
         const getPowerConsumption = async()=>{

           try{
               const response = await ApiService.axiosApi(`/powerconsumption/${Id}`,{
                  method:'GET'
               })
               if(response.success){
                  setData(response.data)
               }else{
                 console.log(response.message||response.status)
               }
           }catch(error){
             console.log(error);
           }

        }
        if(Id) getPowerConsumption();
    
    },[Id])

    useEffect(()=>{
        const getPumpStation =async()=>{
            try{  
                const response = await ApiService.axiosApi(`/pumpingstation`,{
                    method:'GET',
                    params:{
                        pageNumber:0,
                        pageSize:0
                    }
                })
                if(response.success){
                    setPumpStationData(response.data.data)
                }else{
                    console.log(response.message||response.status||'unable to et pump station data')
                }
            }catch(error){
                console.log(error)
            }
       }

       getPumpStation();
    },[])
    
    const onSubmit =async(data:any)=>{
          
           const sendData = {
            powerConsumption_KWH:data.PowerConsumption_KWH,
            Id:data.Id,
            DateTime:data.DateTime
           }
          try{
              const response = await ApiService.axiosApi(`/powerconsumption/${Id}`,{
                 method:'PUT',
                 data:sendData
              })
              if(response.success){
                 toast.success('Power Consumption Updated')
                 navigate(-1)
              }else{
                 toast.error('Failed To Update Power Consumption')
              }
          }catch(error){
             console.log(error)
          }
    }

     
    return(
         <>
           <Update
               title ='Update Power Consumption'
               parentTitle='Power Consumption'

               fields ={
                  [
                      {
                        name:'PowerConsumption_KWH',
                        label:'PowerConsumption_KWH',
                        type:'text'
                      },
                      {
                        
                            name: "DateTime",
                            label: "Date Time",
                            isDateTime: true,
                        

                      }
                  ]

               }
               onSubmit={onSubmit}
               initialData={initialData}
            />
         </>
    )
}

export default PowerConsumptionUpdate;